var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-badge',{attrs:{"status":_vm.colorMap[_vm.status],"text":_vm.$t(("LadingCodePrintStatus." + (_vm.LadingCodePrintStatus[_vm.status])))}})}
var staticRenderFns = []

export { render, staticRenderFns }